// extracted by mini-css-extract-plugin
module.exports = {"imageHolder":"e_rab","imageUI":"e_sab","badgeContainer":"e_tab","badgeImage":"e_uab","container":"e_vab"};